<script setup lang="ts">
    defineOptions({ name: 'AccountPage' });

    const { isLoggedIn } = useLoginState();
    const { t } = useI18n();
    const { lang } = useLanguage();
    const runtimeConfig = useRuntimeConfig();

    useHead({
        title: `${t('account.header')} | ${runtimeConfig.public.defaultTitleSuffix}`,
        htmlAttrs: {
            lang: lang.value
        }
    });
</script>

<template>
    <div>
        <LayoutHeader>
            <template #custom-user-actions>
                <AccountMenu />
                <HeaderCart />
            </template>
        </LayoutHeader>
        <LayoutNotifications />
        <div class="account-wrapper">
            <div
                v-if="isLoggedIn"
                class="account-grid"
            >
                <AccountSidebar />
                <main class="account-content">
                    <slot />
                </main>
            </div>
        </div>

        <LayoutFooter />
    </div>
</template>

<style scoped>
    @import '~/assets/scss/account/account.scss';
</style>
